import { render, staticRenderFns } from "./PaketKuesioner.vue?vue&type=template&id=048565d5&"
import script from "./PaketKuesioner.vue?vue&type=script&lang=js&"
export * from "./PaketKuesioner.vue?vue&type=script&lang=js&"
import style0 from "./PaketKuesioner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports